<template>
    <div>
        <ConfirmDialog
            :is-open="confirmDeleteScreenGroupDialog"
            :data="screenGroup"
            @on-confirm="deleteScreenGroup"
            @on-abort="closeDeleteScreenGroupDialog"
        >
            <template #title>
                Usuwanie grupy
            </template>
            <template #content>
                Czy na pewno chcesz usunąć grupę?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>
        <ScreenGroupDialog
            :is-open="screenGroupDialog"
            :screen-group-data="screenGroup"
            :outdoors-localization-screen-data="screenGroup"
            @get-outdoors-localization-screen-groups="getScreenGroups"
            @on-close="closeScreenGroupDialog"
        />
        <v-container class="pa-5" fluid>
            <v-row align="center" dense>
                <v-col cols="auto">
                    <page-title>Lista z grupami nośników bb</page-title>
                </v-col>
            </v-row>

            <v-row align="center">
                <v-col cols="12" lg="4">
                    <v-btn
                        color="secondary"
                        medium
                        data-sentry-label="Dodaj grupę"
                        @click="showCreateScreenGroupDialog()"
                    >
                        <v-icon left>
                            mdi-plus
                        </v-icon>
                        Dodaj grupę
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-data-table
                            :headers="headers"
                            :items="screenGroups"
                            :loading="screenGroupsLoading"
                            :footer-props="footerProps"
                            :page.sync="pagination.page"
                            :server-items-length="pagination.itemsLength"
                            :mobile-breakpoint="0"
                            name="outdoorsCampaignData"
                            @pagination="updatePagination"
                        >
                            <template #item.name="{item}">
                                {{ item.name }}
                            </template>
                            <template #item.customer="{item}">
                                <template v-if="item.customer">
                                    {{ item.customer.name }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </template>
                            <template #item.actions="{item}">
                                <div class="d-inline-flex">
                                    <v-tooltip :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn
                                                icon
                                                data-sentry-label="Otwórz"
                                                v-on="on"
                                                @click="openScreenGroup(item)"
                                            >
                                                <v-icon color="blue">
                                                    mdi-ballot
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Otwórz</span>
                                    </v-tooltip>
                                    <v-tooltip :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn
                                                icon
                                                data-sentry-label="Otwórz"
                                                v-on="on"
                                                @click="showConfirmDeleteScreenGroup(item)"
                                            >
                                                <v-icon color="pink">
                                                    mdi-delete
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Usuń</span>
                                    </v-tooltip>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
import ScreenGroupDialog from '@/views/Outdoors/Common/OutdoorsLocalizationScreenGroupDialog'
import ConfirmDialog from '@/components/common/ConfirmDialog'

export default {
    name: 'OutdoorsBBTrackingList',
    components: {
        PageTitle,
        ScreenGroupDialog,
        ConfirmDialog
    },
    mixins: [
        pagination,
        tooltipDelay,
    ],
    data() {
        return {
            screenGroupDialog: false,
            confirmDeleteScreenGroupDialog: false,
            actionLoading: false,
            screenGroup: {},
            screenGroupId: null,
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Klient',
                    value: 'customer',
                    sortable: false
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        screenGroups() {
            return this.$store.state.outdoors.outdoorsSettings.outdoorsLocalizationScreenGroups.localizationScreenGroups
        },
        screenGroupsLoading() {
            return this.$store.state.outdoors.outdoorsSettings.outdoorsLocalizationScreenGroups.localizationScreenGroupsLoading
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
    },
    mounted() {
        this.getScreenGroups()
    },
    methods: {
        getScreenGroups() {
            this.$store.dispatch('outdoors/outdoorsSettings/getLocalizationScreenGroups', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showCreateScreenGroupDialog() {
            this.screenGroupDialog = true
        },
        closeScreenGroupDialog() {
            this.screenGroupDialog = false
            setTimeout(() => {
                this.screenGroup = {}
            }, 500)
        },
        closeDeleteScreenGroupDialog() {
            this.confirmDeleteScreenGroupDialog = false
            setTimeout(() => {
                this.screenGroup = {}
            }, 500)
        },
        openScreenGroup(screenGroup) {
            this.screenGroup = screenGroup
            this.screenGroupDialog = true
        },
        showConfirmDeleteScreenGroup(screenGroup) {
            this.screenGroup = screenGroup
            this.confirmDeleteScreenGroupDialog = true
        },
        deleteScreenGroup() {
            this.$store.dispatch('outdoors/outdoorsSettings/deleteLocalizationScreenGroup', this.screenGroup.id)
                .then(() => {
                    this.getScreenGroups()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeDeleteScreenGroupDialog()
                })
        },
        updatePagination(pagination) {
            this.pagination = pagination
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getScreenGroups()
            }
            this.clearPaginationPending()
        }
    },
}
</script>

